import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { getTimeInUserTimeFormat } from 'modules/surveys/lib/getTimeInUserTimeFormat'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import type { SurveyFactorialFormSchema } from '../Settings/CycleConfiguration'
import { frequencyOptionLabel } from '../Settings/CycleOptions'

interface RestartSurveyModalProps {
  survey: Survey
  onClose: () => void
  surveyData: SurveyFactorialFormSchema
}

const StartSurveyModal = ({ survey, onClose, surveyData }: RestartSurveyModalProps) => {
  const daysToAnswer = surveyData.duration_in_days
    ? surveyData.duration_in_days
    : i18n
        .t('surveys.form.settings.cycle_configuration.frequency.days_to_answer.placeholder')
        .toLowerCase()

  const descriptionValues = {
    start_on: surveyData.start_on,
    start_at: getTimeInUserTimeFormat(surveyData.scheduled_time),
    days_to_answer: daysToAnswer,
  }
  const description = survey.hasSchedule
    ? i18n.t('surveys.form.start.modal.description_repeat_cycle', {
        ...descriptionValues,
        frequency_option: frequencyOptionLabel().get(surveyData.frequency)?.toLowerCase(),
      })
    : i18n.t('surveys.form.start.modal.description', descriptionValues)

  const { running, performAction: startSurvey } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await survey.startSurvey()
      survey.fetch()
      closePortal()
    }
  )

  return (
    <Modal
      illustration="calendar-clock"
      title={i18n.t('surveys.form.start.modal.title')}
      description={description}
      onClose={onClose}
      onSubmit={startSurvey}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(StartSurveyModal)
